// extracted by mini-css-extract-plugin
export default {"wrapper":"AWSC_wrapper__1Gc4H"};